package dev.wyns.ventrova.platform

import dev.wyns.ventrova.data.model.Place
import kotlinx.browser.localStorage
import kotlinx.browser.window

/** Stores values in localStorage; falls back to memory when storage is blocked. */
class WebKeyValueStore : KeyValueStore {
    private val fallback = InMemoryKeyValueStore()

    override fun getBoolean(key: String, default: Boolean): Boolean =
        read(key)?.toBooleanStrictOrNull() ?: fallback.getBoolean(key, default)

    override fun putBoolean(key: String, value: Boolean) {
        fallback.putBoolean(key, value)
        write(key, value.toString())
    }

    override fun getStringSet(key: String): Set<String> =
        read(key)?.let { JSON.parse<Array<String>>(it).toSet() } ?: fallback.getStringSet(key)

    override fun putStringSet(key: String, value: Set<String>) {
        fallback.putStringSet(key, value)
        write(key, JSON.stringify(value.toTypedArray()))
    }

    private fun read(key: String): String? = try {
        localStorage.getItem(PREFIX + key)
    } catch (_: Throwable) {
        null
    }

    private fun write(key: String, value: String) {
        try {
            localStorage.setItem(PREFIX + key, value)
        } catch (_: Throwable) {
            // Storage blocked (private mode, disabled site data): keep the in-memory value.
        }
    }

    private companion object {
        const val PREFIX = "ventrova."
    }
}

class WebExternalActions : ExternalActions {
    override fun openDirections(place: Place) {
        val destination = "${place.location.latitude},${place.location.longitude}"
        window.open("https://www.google.com/maps/dir/?api=1&destination=$destination&travelmode=walking", "_blank")
    }

    override fun call(phone: String) {
        window.location.href = "tel:${phone.filterNot { it.isWhitespace() }}"
    }

    override fun openWebsite(url: String) {
        window.open(normalizedUrl(url), "_blank")
    }

    override fun share(place: Place) {
        val navigator: dynamic = window.navigator
        if (navigator.share != undefined) {
            val data: dynamic = js("{}")
            data.title = place.name
            data.text = place.shareText()
            navigator.share(data)
        } else {
            place.website?.let { openWebsite(it) }
        }
    }
}
